/**
 * 댓글 관련 API 모음
 */
import {
  ApiResponse,
  CreateCommentRequest,
  CreateCommentResponse,
  GetCommentsResponse,
  CommentLikeToggleRequest,
  CommentLikeToggleResponse,
} from '../types/Comment.api.type';
import apiClient from '../axios';

/** * 댓글 API 주소 */
const COMMENT_URL = () => '/api/comment';
export const commentApi = {
  /**
   * 댓글 등록 API
   */
  createComment: (params: CreateCommentRequest) => {
    console.log('commentApi.createComment', params);
    return apiClient.post<ApiResponse<CreateCommentResponse>>(`${COMMENT_URL()}/createComment`, params);
  },

  /**
   * 댓글 조회 API (좋아요 상태 포함)
   */
  getComments: (questionId: string, fingerprint?: string | null) => {
    console.log('commentApi.getComments', questionId);
    const params: Record<string, string> = {};
    if (fingerprint) {
      params.fingerprint = fingerprint;
    }
    return apiClient.get<ApiResponse<GetCommentsResponse[]>>(`${COMMENT_URL()}/getComments/${questionId}`, { params });
  },

  /**
   * 댓글 좋아요 토글 API
   */
  toggleLike: (params: CommentLikeToggleRequest) => {
    return apiClient.post<CommentLikeToggleResponse>(`${COMMENT_URL()}/like`, params);
  },
};
